angular.module('dpw.components')
/**
 * @ngdoc directive
 * @name dpwPhoneNumberValidator
 * @restrict A
 * @require ngModel
 * @description
 * Add phone number validator to ngModel.
 * @example
 * <input ng-model="$ctrl.phoneNumber" dpw-phone-number-validator />
 */
    .directive('dpwPhoneNumberValidator', [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {},
                link: function (scope, element, attrs, ngModel) {
                    var pattern = /^[-\d()\t +]+$/;

                    ngModel.$validators.dpwPhoneNumberValidator = function (modelValue, viewValue) {
                        var value = modelValue || viewValue;
                        return pattern.test(value);
                    };
                }
            };
        }]
    );